enum OperationTempReadingTypeEnum {
  cooling = 'operation_temp_cooling',
  reheating = 'operation_temp_reheating',
  service = 'operation_temp_service',
  delivery = 'operation_temp_delivery',
}

export default OperationTempReadingTypeEnum;
